export default class SongCollection {
    id: number = 0;
    song_name: string = "";
    song_cover_s3_link: string = "";
    artist_wallet_address: string = '';
    artist_stage_name: string = "";
    description: string = "";
    nft_address: string = "";
    launch_date: number = 0;
    mint_price: number = 0;
    preview_song_url: string = "";
    quantity: number = 0;
    minted: number = 0;
    for_secondary_sale: boolean = false;
    royalty_percentage: number = 0;
    secondary_sale_qty: number = 0;
    floor_price: number = 0;
    spotify_url: string = '';
    youtube_url: string = '';
    metadata_base_url: string = '';
  }
  
  export interface SongCollectionResponse {
    songCollectionDetails: SongCollection;
  }
  